<template>
  <div>
    <!--搜索条件-->
    <div class="searchbar">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="用户名称">
          <el-input v-model="filters.username" placeholder="用户名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="findPage()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格栏-->
    <div class="table-wrap">
      <el-table :data="tableData.data" stripe highlight-current-row max-height="460" size="small"
                style="width:100%;">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column v-for="column in columns" header-align="center" align="center"
                         :prop="column.prop" :label="column.label" :width="column.width"
                         :min-width="column.minWidth"
                         :fixed="column.fixed" :key="column.prop" :type="column.type">
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right" header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="icon-xs icon-edit" title="编辑" @click="handleEdit(scope.$index, scope.row)"></i>
            <i class="icon-xs icon-delete offset-left30" title="删除"
               @click="handleDelete(scope.$index, scope.row)"></i>
            <i class="icon-xs icon-refresh offset-left30" title="重置密码"
               @click="handleRestEdit(scope.$index, scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding:10px;">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="refreshPageRequest"
                       :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize"
                       :total="tableData.totalSize" style="float:right;">
        </el-pagination>
      </div>
    </div>

    <el-dialog v-dialogDrag :title="operation==='add'?'新增':'编辑'" width="40%" :visible.sync="dialogVisible"
               :close-on-click-modal="false">
      <el-form :model="adminUserForm" :rules="rules" label-width="80px" ref="adminUserForm" size="small"
               label-position="right">
        <el-form-item label="adminUserId" prop="adminUserId" v-if="false">
          <el-input v-model="adminUserForm.adminUserId" :disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="username">
          <el-input v-model="adminUserForm.username" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="operation==='add'">
          <el-input v-model="adminUserForm.password" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPassword" v-if="operation==='add'">
          <el-input v-model="adminUserForm.checkPassword" type="password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click.native="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('adminUserForm')">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title="重置密码" width="40%" :visible.sync="dialogResetVisible"
               :close-on-click-modal="false">
      <el-form :model="adminUserResetForm" :rules="resetRules" label-width="80px" ref="adminUserResetForm"
               size="small"
               label-position="right">
        <el-form-item label="密码" prop="password">
          <el-input v-model="adminUserResetForm.password" type="password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click.native="dialogResetVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitRestForm()">确认</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {Message} from 'element-ui';

export default {
  name: 'user',
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === null) {
        callback(new Error('请输入密码'));
      } else {
        if (this.adminUserForm.checkPassword !== '') {
          this.$refs.adminUserForm.validateField('checkPassword');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === null) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.adminUserForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      filters: {
        username: null
      },
      tableData: {
        'totalSize': 0,
        'data': []
      },
      columns: [
        {prop: 'username', label: '用户名称', minWidth: 120},
      ],
      pageRequest: {
        pageNum: 1,
        pageSize: 10
      },
      dialogVisible: false,
      dialogResetVisible: false,
      operation: '',
      adminUserForm: {
        adminUserId: null,
        username: null,
        password: null,
        checkPassword: null
      },
      adminUserResetForm: {
        adminUserId: null,
        password: null,
      },
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {validator: validatePass, trigger: 'blur', required: true}
        ],
        checkPassword: [
          {validator: validatePass2, trigger: 'blur', required: true}
        ],
      },
      resetRules: {
        password: [
          {message: '请输入密码', trigger: 'blur', required: true}
        ],
      }
    }
  },
  methods: {
    // 分页查询
    findPage() {
      let adminUserRequestData = {
        username: this.filters.username,
        pageNo: this.pageRequest.pageNum,
        pageSize: this.pageRequest.pageSize,
      };
      this.$api.adminUser.selectAdminUser(adminUserRequestData).then((res) => {
        this.tableData.totalSize = res.total;
        this.tableData.data = res.list;
      });
    },
    // 换页刷新
    refreshPageRequest: function (pageNum) {
      this.pageRequest.pageNum = pageNum;
      this.findPage()
    },
    // 编辑
    handleEdit: function (index, row) {
      this.dialogVisible = true;
      this.operation = 'edit';
      this.adminUserForm.adminUserId = row.adminUserId;
      this.adminUserForm.username = row.username;
    },
    handleRestEdit: function (index, row) {
      this.dialogResetVisible = true;
      this.adminUserResetForm.adminUserId = row.adminUserId;
    },
    // 删除
    handleDelete: function (index, row) {
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$api.adminUser.deleteAdminUser(row.adminUserId).then(() => {
          this.refreshPageRequest(1);
          Message.success({message: '删除成功'});
        });
      }).catch(() => {
      });
    },
    //新增
    handleAdd: function () {
      this.dialogVisible = true;
      this.operation = 'add';
      this.$nextTick(() => {
        this.adminUserForm = {};
        if (this.$refs['adminUserForm'] !== undefined) {
          this.$refs['adminUserForm'].resetFields();
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.operation === 'edit') {
            let adminUserRequestData = {
              username: this.adminUserForm.username,
            };
            this.$api.adminUser.updateAdminUser(adminUserRequestData, this.adminUserForm.adminUserId).then(() => {
              this.dialogVisible = false;
              this.$refs['adminUserForm'].resetFields();
              this.$message.success('修改成功');
              this.findPage();
            });
          } else {
            let adminUserRequestData = {
              username: this.adminUserForm.username,
              password: this.adminUserForm.password,
            };
            this.$api.adminUser.insertAdminUser(adminUserRequestData).then(() => {
              this.dialogVisible = false;
              this.$refs['adminUserForm'].resetFields();
              this.$message.success('新增成功');
              this.findPage();
            });
          }
        } else {
          this.$message.error('验证失败');
          return false;
        }
      });
    },
    submitRestForm() {
      this.$refs['adminUserResetForm'].validate((valid) => {
        if (valid) {
          let adminUserRequestData = {
            password: this.adminUserResetForm.password,
          };
          this.$api.adminUser.updateAdminUserPassword(adminUserRequestData, this.adminUserResetForm.adminUserId).then(() => {
            this.dialogResetVisible = false;
            this.$refs['adminUserResetForm'].resetFields();
            this.$message.success('重置成功');
            this.findPage();
          });
        } else {
          this.$message.error('验证失败');
          return false;
        }
      });
    },
  },
  components: {},
  mounted() {
    this.refreshPageRequest(1)
  },
}
</script>

<style scoped>


</style>